import { Component, OnInit, Output, EventEmitter, OnDestroy, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-session-warning-modal',
    templateUrl: './session-warning-modal.component.html',
    styleUrls: ['./session-warning-modal.component.scss']
})
export class SessionWarningModalComponent implements OnInit, OnDestroy {
    @Output() stayLoggedIn = new EventEmitter<void>();
    @Output() logoutNow = new EventEmitter<void>();
    @Input() remainingSeconds: number = 0;

    remainingMinutes: number = 2;
    formattedTime: string = '2:00';
    isButtonsDisabled: boolean = false;

    private destroy$ = new Subject<void>();

    constructor() { }

    ngOnInit(): void { }

    public updateCountdown(secondsRemaining: number): void {
        this.remainingSeconds = Math.floor(secondsRemaining);
        this.remainingMinutes = Math.floor(this.remainingSeconds / 60);
        const seconds = this.remainingSeconds % 60;
        this.formattedTime = `${this.remainingMinutes}:${seconds.toString().padStart(2, '0')}`;
    }

    ngOnChanges(): void {
        if (this.remainingSeconds > 0) {
            this.updateCountdown(this.remainingSeconds);
        }
    }

    public onStayLoggedIn(): void {
        this.disableAllButtons();
        this.stayLoggedIn.emit();
    }

    public onLogoutNow(): void {
        this.disableAllButtons();
        this.logoutNow.emit();
    }

    private disableAllButtons(): void {
        this.isButtonsDisabled = true;
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}